<script>
  export let percent = 20;
  export let show_percent = true;
  export let color="var(--value7)";
</script>

<style>
  progress-meter {
    width: 100%;
  }

  progress-meter bar {
    height: 10px;
  }
</style>

<progress-meter>
  <bar style="width: { percent }%; background-color: { color };">{#if show_percent}{ percent }%{/if}</bar>
</progress-meter>
